<template>
    <button :class="className" :name="name" v-on:click="onClick" :disabled="disabled">
        {{ text }}
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ButtonBlue',
    props: {
        text: { type: String, required: true },
        onClick: { type: Function, required: true },
        name: { type: String, required: false },
        disabled: { type: Boolean, required: false },
        className: { type: String, required: false },
    },
});
</script>

<style scoped>
button {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
    height: 38px;
    padding: 0 8px;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
}
.blueBtn {
    border: none;
    background-color: var(--color-principal);
    color: var(--white);
}
.blueBtn:disabled {
    background-color: var(--button-color-disabled);
    cursor: default;
}
.whiteBtn {
    background-color: var(--white);
    border: 1px solid var(--color-principal);
    color: var(--color-principal);
}
.whiteBtn:disabled {
    background-color: var(--background-color-disabled);
    cursor: default;
}
.redBtn {
    background-color: var(--white);
    border: 1px solid var(--red);
    color: var(--red);
}

.redBtn:disabled {
    background-color: var(--button-color-disabled);
    border: none;
    color: var(--white);
    cursor: default;
}

.greenBtn {
    background-color: var(--white);
    border: 1px solid var(--medium-green);
    color: var(--medium-green);
}
</style>
